/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventnotfound2Inputs */

const en_eventnotfound2 = /** @type {(inputs: Eventnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Not Found`)
};

const de_eventnotfound2 = /** @type {(inputs: Eventnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Event Not Found" |
*
* @param {Eventnotfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventnotfound2 = /** @type {((inputs?: Eventnotfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventnotfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventnotfound2(inputs)
	return de_eventnotfound2(inputs)
});
export { eventnotfound2 as "eventNotFound" }